var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResidentSelectableCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81369 7.12295C3.62269 7.12295 3.42969 7.04995 3.28369 6.90295L0.909691 4.52995C0.616691 4.23695 0.616691 3.76295 0.909691 3.46995C1.20269 3.17695 1.67669 3.17695 1.96969 3.46995L3.81369 5.31195L8.02969 1.09695C8.32269 0.803947 8.79669 0.803947 9.08969 1.09695C9.38269 1.38995 9.38269 1.86395 9.08969 2.15695L4.34369 6.90295C4.19769 7.04995 4.00569 7.12295 3.81369 7.12295Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResidentSelectableCheck);
export default __webpack_public_path__ + "static/media/iconResidentSelectableCheck.3e70dbf1edbf28e5ff4c36c34c3b8905.svg";
export { ForwardRef as ReactComponent };